export default __webpack_public_path__ + "static/media/about_emp1.ea27219f.png";